import {EventTypeViewModel} from "./event-type-view-model";
import {EventTypeImageRequestParams} from "./event-type.image-request-params";

export class EventSubTypeImageRequestParams extends EventTypeImageRequestParams {
  subTypeId: Number;
  id: Number;

  constructor(model: EventTypeViewModel, width: Number = 32, height: Number = 32, ratio: Number) {
    super(model, width, height, ratio);

    this.resourceName = `NewBrand25/EventSubType`;
  }
  get pathPostfix(): String {
    return `${this.versionPath}/${this.resourceName}/${this.theme}/${this.subTypeId}`;
  }
}
